import { HotelAccessCodesList } from '@/components/hotel-access-codes/HotelAccessCodesList';
import { PageContainer } from '@startupquickstart/frontend';

/**
 * Hotel Access Codes list page
 */
export function HotelAccessCodesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Hotel Access Codes', current: true },
  ];

  return (
    <PageContainer>
      <HotelAccessCodesList breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
